import React from 'react'
import { Button, Icon } from 'antd'
import { UserAvatar } from 'modules/atoms/user-avatar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const headers = (onRemove?: (token: string) => void, t?: any, ordered?: boolean) => {
  
  let columns = [
    {
      key: 'icon',
      title: '',
      visible: true,
      render: (_: any) => {
        return <Icon type="menu" />
      }
    },
    {
      key: 'order',
      title: t('signature.global.rows.signedOrder'),
      render: (_: any, __: any, index: any) => {
        return <span>{index + 1}</span>
      },
      visible: ordered
    },
    {
      key: 'name',
      title: t('signature.global.rows.name'),
      visible: true,
      render: (_: any, user: any) => (
        <UserAvatar
          avatar={user?.avatar_url}
          name={`${user?.name} ${user?.lastname}`}
        />
      )
    },
    {
      key: 'email',
      title: 'Email',
      visible: true,
      render: (_: any, user: any) => <span>{user.email}</span>
    },
    {
      key: 'area',
      title: t('signature.global.rows.area'),
      visible: true,
      render: (_: any, user: any) => <span>{user.area?.name}</span>
    },
    {
      key: 'position',
      title: t('signature.global.rows.position'),
      visible: true,
      render: (_: any, user: any) => <span>{user.position?.name}</span>
    },
    {
      key: 'actions',
      title: '',
      visible: true,
      render: (_: any, user: any) => (
        <Button className='removeButton' onClick={() => onRemove?.(user.token)}>
          <FontAwesomeIcon icon={faTrash as IconProp} />
        </Button>
      )
    }
  ]

  return columns.filter(col => col.visible)
}
